import React from 'react';
import { useSelector } from 'react-redux';
import { SwiperSlide } from 'swiper/react';
import './GridPageStripGamesDesignLandscapeMultiRow.css';
import './GridPageStripGamesDesignLandscapeSingleRow.css';
import { ThumbnailInLoadingState } from '../../GameThumbnails/ThumbnailInLoadingState';
import { GridPageStripGamesSwiper } from '../GridPageStripGamesSwiper';

const renderPreloadThumbnails = (rowsNum = 1) => {
    const gamesToRender = (new Array(20)).fill(undefined);
    const gamesCount = gamesToRender.length;
    const result = [];

    const outputLoadingThumbnails = startPoint => {
        const thumbnails = [];
        for (let i = 0; i < rowsNum; i++) {
            const key = `${startPoint}-${i}`;
            thumbnails.push(startPoint + i < gamesCount
                ? <ThumbnailInLoadingState key={key} />
                : <div className="casino-thumbnail" key={key}></div>
            );
        }
        return thumbnails;
    };

    for (let i = 0; i < gamesCount; i += rowsNum) {
        result.push((
            <SwiperSlide key={i}>
                {outputLoadingThumbnails(i)}
            </SwiperSlide>
        ));
    }

    return result;
};

const renderGamesThumbnails = (gamesToRender, renderFn, rowsNum = 1) => {
    const renderedGames = gamesToRender
        .map(gameId => renderFn(gameId))
        .filter(item => item);
    const gamesCount = renderedGames.length;
    const result = [];

    const outputGameThumbnails = startPoint => {
        const thumbnails = [];
        for (let i = 0; i < rowsNum; i++) {
            const currentPoint = startPoint + i;

            thumbnails.push(currentPoint < gamesCount
                ? renderedGames[currentPoint]
                : <div className="casino-thumbnail" key={`${startPoint}-${i}`}></div>
            );
        }
        return thumbnails;
    };

    for (let i = 0; i < gamesCount; i += rowsNum) {
        result.push((
            <SwiperSlide key={i}>
                {outputGameThumbnails(i)}
            </SwiperSlide>
        ));
    }

    return result;
};

export const GridPageStripGamesDesignLandscapeMultiRow = ({ games, renderCasinoThumbnailFn, strip }) => {
    const rowsNum = 2;
    const gamesToRender = games.slice(0, 50); // limit games number to optimize performance
    const { platformGamesReady } = useSelector((state) => state.app);
    const itemsToRender = platformGamesReady
        ? renderGamesThumbnails(gamesToRender, renderCasinoThumbnailFn, rowsNum)
        : renderPreloadThumbnails(rowsNum);

    return (
        <GridPageStripGamesSwiper
            wrapperClassName="grid-pages-landscape-multi-row"
            strip={strip}
        >
            {itemsToRender}
        </GridPageStripGamesSwiper>
    );
};

export const GridPageStripGamesDesignLandscapeSingleRow = ({ games, renderCasinoThumbnailFn, strip }) => {
    const gamesToRender = games.slice(0, 50); // limit games number to optimize performance
    const { platformGamesReady } = useSelector((state) => state.app);
    const itemsToRender = platformGamesReady
        ? renderGamesThumbnails(gamesToRender, renderCasinoThumbnailFn)
        : renderPreloadThumbnails();

    return (
        <GridPageStripGamesSwiper
            wrapperClassName="grid-pages-strip-landscape-single-row"
            strip={strip}
        >
            {itemsToRender}
        </GridPageStripGamesSwiper>
    );
};
